var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('g-chart',{attrs:{"settings":{ packages: ['timeline'] },"data":_vm.dataTable,"options":_vm.chartOptions,"create-chart":_vm.customCreate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }